import Home from './Home';

export default function HomeGateway() {
  return <Home />;
}
